// https://shopify.dev/docs/api/usage/gids#parameterized-global-ids
const SHOPIFY_ID_REGEX = /^gid:\/\/shopify\/(?:[A-Za-z]+)\/(\d+(\?.+)?)$/;

export const shopifyGidToId = (gid: string) =>
  gid?.match(SHOPIFY_ID_REGEX)?.[1] ?? gid;

type ShopifyObjectType =
  | 'Product'
  | 'ProductVariant'
  | 'Order'
  | 'Customer'
  | 'Collection';

const shopifyIdToGidMap: Record<ShopifyObjectType, string> = {
  Product: 'gid://shopify/Product/',
  ProductVariant: 'gid://shopify/ProductVariant/',
  Order: 'gid://shopify/Order/',
  Customer: 'gid://shopify/Customer/',
  Collection: 'gid://shopify/Collection/'
};

export const shopifyIdToGid = (id: string, type: ShopifyObjectType) => {
  return shopifyIdToGidMap[type] + id;
};
